import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "stepper" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = { class: "head" }
const _hoisted_4 = { class: "content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Divider = _resolveComponent("Divider")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.steps, (step, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: "step-item"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "icon", {
            step: step,
            idx: idx
          }, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "head", {
            step: step,
            idx: idx
          }, undefined, true)
        ]),
        _createVNode(_component_Divider, {
          class: "line",
          dashed: $props.collapsed && idx === $props.steps.length - 1,
          m: "0 auto",
          vertical: "",
          style: _normalizeStyle({opacity: !$props.collapsed && idx === $props.steps.length - 1 ? 0 : 1})
        }, null, 8 /* PROPS */, ["dashed", "style"]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "content", {
            step: step,
            idx: idx
          }, undefined, true)
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}